import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { RootState } from '../store';

type AppThunkDispatch = ThunkDispatch<RootState, void, Action>;
export const useAppDispatch = (): AppThunkDispatch => useDispatch();
